import React from 'react';
import { useAuthContext } from '../context/AuthContext';

export const NonAdminPreviewBanner: React.FC = () => {
  const { canUseNonAdminPreview, isNonAdminPreview, exitNonAdminPreview } = useAuthContext();

  if (!canUseNonAdminPreview || !isNonAdminPreview) return null;

  return (
    <div className="mb-4 flex items-center justify-between gap-3 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <span>Previewing the labeler experience.</span>
      <button
        type="button"
        className="rounded-md border border-amber-300 bg-white px-3 py-1 font-semibold text-amber-900 hover:bg-amber-100"
        onClick={exitNonAdminPreview}
      >
        Exit preview
      </button>
    </div>
  );
};
